import { configService } from "../../services/Config/configService.js";


export const ConfigStore = {
    namespaced: true,
    state: {
        endpoints: {
            loginAPI: "/login",
            // vista comercios
            getListarCategoriasActivasComercio: "/categoriasComercio/listarActivas",
            getListarComercios: "/comercios/listarActivos",
            getFotosComercios: "/fotosComercio/listarPorComercio",
            //vista Cancelar Reserva
            getObtenerProductoCancelar:"/productos/obtenerProductoCancelar",
            deleteCancelarProducto: "/usuariosReusapp/cancelarReserva",
            
        },
        overlay: false
    },
    mutations: {
        setConfig(state, payload) {
            state.endpoints = payload.data.endpoints;
        },
        SET_OVERLAY(state, payload) {
            state.overlay = payload;
        },
    },
    actions: {
        getConfigJSON: async function({ commit }) {
            const response = await configService();
            if (response.data != null) {
                commit("setConfig", response);
            }
            return response;
        },
        setOverlay: async function({ commit }, overlay) {
            commit('SET_OVERLAY', overlay)
        }
    },
    getters: {
        getEndpoints(state) {
            return state.endpoints;
        },
        getOverlay(state) {
            return state.overlay;
        }
    },
};